import styled from "styled-components";

export const StyledStage = styled.div`
	display: grid;
	grid-template-rows: repeat(
		${(props) => props.height},
		calc(25vw / ${(props) => props.width})
	);
	grid-template-columns: repeat(${(props) => props.width}, 3fr);
	grid-gap: 2px;
	border: 2px solid #333;
	width: 100%;
	max-width: 25vw;
	background: #111;
	z-index: 100;
	@media (max-width: 1500px) {
		margin-top: 10%;
		transform: scale(1.2);
	}
	@media (max-width: 1000px) {
		margin-top: 20%;
		margin-left: 20vw;
		transform: scale(1.6);
	}
`;
